import { jsxs as O, jsx as l } from "react/jsx-runtime";
import { useField as x, ErrorMessage as y } from "formik";
import { isString as $, isNumber as A } from "lodash-es";
import { useCallback as p } from "react";
import B from "react-select/async";
import { Error as F } from "../Error/Error.js";
import L from "./Components/index.js";
import { Wrapper as P, Label as j, Select as k, HintLabel as H, ErrorWrapper as N } from "./styled.js";
function I(i) {
  const {
    name: e,
    label: a = "",
    minLength: d = 3,
    onChange: s = () => {
    },
    onBlur: m = () => {
    },
    openMenuOnClick: f = !0,
    openMenuOnFocus: h = !0,
    loadOptions: b,
    hint: u,
    ...g
  } = i, [{ value: o }, c, n] = x(e), C = !!(c.touched && c.error), v = (r = "") => r.length >= d ? b(r) : Promise.resolve([]);
  let t;
  $(o) ? t = {
    label: o.trim(),
    value: o.trim()
  } : A(o) ? t = {
    label: o.toString(),
    value: o.toString()
  } : t = o;
  const S = p(
    (r, M) => {
      n.setValue(r), s(r, M);
    },
    [n, s]
  ), E = p(
    (r) => {
      n.setTouched(!0, !1), m(r);
    },
    [m, n]
  );
  return /* @__PURE__ */ O(P, { children: [
    /* @__PURE__ */ l(j, { htmlFor: e, id: `${e}.label`, children: a }),
    /* @__PURE__ */ l(
      B,
      {
        "aria-label": a,
        id: e,
        name: e,
        classNamePrefix: `Select_${e}`,
        openMenuOnClick: f,
        openMenuOnFocus: h,
        value: t,
        onChange: S,
        onBlur: E,
        loadOptions: v,
        styles: k(C),
        components: L({ ...i, value: t }),
        ...g
      }
    ),
    u && /* @__PURE__ */ l(H, { children: u }),
    /* @__PURE__ */ l(N, { children: /* @__PURE__ */ l(y, { name: e, children: (r) => /* @__PURE__ */ l(
      F,
      {
        "aria-invalid": !0,
        "aria-labelledby": `${e}.label`,
        "data-testid": `${e}-AutoCompleteError`,
        children: r
      }
    ) }) })
  ] });
}
export {
  I as AutoComplete,
  I as default
};
